const cache = {
  lastSchema: null,
  lastSolutionId: null,
};

export default cache;
